/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `coach` - Coach
* `player` - Player
* `contact` - Contact
* `admin` - Admin
* `instructor` - Instructor
 */
export type ProfileRole = typeof ProfileRole[keyof typeof ProfileRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfileRole = {
  coach: 'coach',
  player: 'player',
  contact: 'contact',
  admin: 'admin',
  instructor: 'instructor',
} as const;
